import React from 'react';
import { Link } from 'react-router-dom';

// What a Ship just did (issue #269): the shipment's number and, when Ship
// invoiced it, its Invoice, which opens the Invoice. Stays until closed.
export function shippedText(shipment) {
  if (!shipment) return '';
  const invoice = shipment.invoice && !shipment.invoice.voided_at ? shipment.invoice : null;
  return [`Shipped ${shipment.display_number}`, invoice ? `Invoice ${invoice.display_number}` : null].filter(Boolean).join(' · ');
}

function ShippedNotice({ shipment, onClose }) {
  if (!shipment) return null;
  const invoice = shipment.invoice && !shipment.invoice.voided_at ? shipment.invoice : null;
  return (
    <div style={{ margin: '0 0 12px', padding: '8px 12px', background: '#e6f4ea', border: '1px solid #b7dfc3', borderRadius: 6, fontSize: 13, color: '#1e7e34', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 8 }}>
      <span>
        Shipped {shipment.display_number}
        {invoice && (
          <>
            {' · Invoice '}
            <Link to={`/receivables-invoices/${invoice.id}`} title="Open the Invoice" style={{ color: '#1976d2' }}>{invoice.display_number}</Link>
          </>
        )}
      </span>
      <button type="button" onClick={onClose} title="Close" aria-label="Close" style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', color: '#1e7e34', fontSize: 16, lineHeight: 1, padding: 0 }}>×</button>
    </div>
  );
}

export default ShippedNotice;
